module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "expect-job-detail",
    on: {
      "click": _vm.showPopup
    }
  }, [_c('span', {
    staticClass: "title-tip"
  }, [_vm._v("不想从事的行业")]), _vm._v(" "), _c('div', {
    staticClass: "selected-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.selectedText))])])]), _vm._v(" "), _c('checklist', {
    attrs: {
      "data": _vm.list,
      "selects": _vm.selectedItems,
      "max": 5,
      "title": "简历屏蔽行业"
    },
    on: {
      "on-close": _vm.close,
      "on-confirm": _vm.confirm,
      "on-change": _vm.dataChange
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('p', {
    staticClass: "checklist-tips",
    attrs: {
      "slot": "extend"
    },
    slot: "extend"
  }, [_vm._v("我不想让以下行业搜到我的简历（可多选）")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72de51cf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/expectation/privacySetting/privacyIndustry.vue
// module id = 363
// module chunks = 0